"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deprecatedProp = exports.useMemoizedId = exports.mapBsStyleToColor = void 0;
const react_1 = require("react");
const v4_1 = __importDefault(require("uuid/v4"));
const colors = __importStar(require("./colors"));
function createUniqueId(label) {
    const uniqueId = `${label}-${v4_1.default()}`;
    return uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
}
exports.mapBsStyleToColor = (bsStyle, { shade = 'base', fallback = colors.coal } = {}) => {
    let result = colors[bsStyle];
    if (result && result[shade]) {
        result = result[shade];
    }
    else {
        result = fallback;
    }
    return result;
};
/**
 * @param {string} myObj.id If you already have a unique id that you want memoized.
 * @param {string} myObj.label Generate a unique id with the following label.
 */
exports.useMemoizedId = ({ label, id }) => react_1.useMemo(() => id || createUniqueId(label), [label, id]);
function deprecatedProp(validator, suggestion = '') {
    return function deprecated(props, propName, ...rest) {
        if (props[propName] != null) {
            console.warn(`${propName} is deprecated. ${suggestion}`);
        }
        return validator(props, propName, ...rest);
    };
}
exports.deprecatedProp = deprecatedProp;
